export const services = [
  {
    id: "game-dev",
    icon: "ri-gamepad-line",
    title: "Game Development",
    tagline: "From Concept to Console",
    desc: "We craft immersive gaming experiences for mobile, PC, and Web3 platforms. Our full-cycle development process covers game design, art, programming, QA, and live operations.",
    features: [
      "Mobile & PC Game Development",
      "Web3 / NFT Game Integration",
      "Game UI/UX Design",
      "Multiplayer & Backend Systems",
      "Live Operations & Updates",
      "Cross-platform Porting",
    ],
    image: "https://public.readdy.ai/ai/img_res/b089d64213cae8110580e59154267d0f.jpg",
  },
  {
    id: "social-platform",
    icon: "ri-group-line",
    title: "Social Platform Development",
    tagline: "Connect. Compete. Grow.",
    desc: "We build custom social ecosystems that bring gaming communities to life — from Discord-style chat platforms to full-featured community hubs with leaderboards and events.",
    features: [
      "Community Platform Architecture",
      "Real-time Chat & Voice Systems",
      "Leaderboard & Ranking Systems",
      "Tournament Management Tools",
      "Streaming Integration",
      "Analytics & Engagement Tools",
    ],
    image: "https://readdy.ai/api/search-image?query=dark%20modern%20social%20gaming%20platform%20interface%20dashboard%20multiple%20users%20online%20community%20gaming%20hub%20neon%20glow%20dark%20background%20professional&width=700&height=450&seq=svc2&orientation=landscape",
  },
  {
    id: "guild-ops",
    icon: "ri-shield-star-line",
    title: "Guild Operations",
    tagline: "Build Your Empire",
    desc: "Our guild operations service transforms casual player groups into structured, high-performing organizations with management tools, recruitment systems, and competitive frameworks.",
    features: [
      "Guild Management Platform",
      "Recruitment & Onboarding Systems",
      "Internal Economy & Rewards",
      "Event Scheduling & Coordination",
      "Performance Tracking",
      "Multi-game Guild Support",
    ],
    image: "https://readdy.ai/api/search-image?query=dark%20fantasy%20guild%20hall%20digital%20art%20massive%20space%20with%20glowing%20banners%20and%20emblems%20cinematic%20epic%20atmosphere%20dark%20background%20amber%20neon%20lighting&width=700&height=450&seq=svc3&orientation=landscape",
  },
  {
    id: "engineering",
    icon: "ri-code-s-slash-line",
    title: "Backend Engineering",
    tagline: "Scale Without Limits",
    desc: "Our engineering team builds the high-performance infrastructure that powers gaming at scale — real-time servers, APIs, databases, and cloud architectures designed for millions of concurrent users.",
    features: [
      "Cloud Infrastructure Design",
      "Real-time Game Server Development",
      "API Development & Integration",
      "Database Architecture",
      "DevOps & CI/CD Pipelines",
      "Security & Anti-cheat Systems",
    ],
    image: "https://readdy.ai/api/search-image?query=server%20room%20data%20center%20dark%20background%20neon%20green%20lights%20futuristic%20technology%20infrastructure%20professional%20cinematic%20lighting&width=700&height=450&seq=svc4&orientation=landscape",
  },
];
